import * as React from 'react'
import { FormControls } from '../../../../Shared/Frontend/forms'
import { SearchBarProps, SearchButtonProps, SearchFormProps } from './searchBar.state'
import { SharedBlockLayout } from '../modernBlocks/blocks/shared/sharedBlock.layout'
import i18next from 'i18next'
import { SearchPageLayout } from '../customPages/overviewPage/searchPage/searchPage.layout'
import { loadSearchSuggestion } from './loadSearchSuggestions'
import { ParsedOverviewDetailItem } from '../customPages/overviewPage/widgets/overviewWidget.state'

export const SearchFormLayout = (props: SearchFormProps) => (
  <form
    className='searchform__form'
    onSubmit={e => {
      e.preventDefault()
      if (props.submitSearchValue) return props.submitSearchValue()

      window.location.href = `/${window.location.href.includes("/wp/") ? "wp" : ""}/zoeken?searchQuery=${props.searchValue}`
        .replace(/\/\//g, "/")
        .replace(/\/\//g, "/")
    }}
  >
    <label className='sr-text' htmlFor="search-input">{props.label}</label>
    <FormControls.FormItemWithID
      key="search-input"
      controlId="search-input"
      type='search'
      inputMode='text'
      disabled={false}
      required={false}
      value={props.searchValue}
      label={props.label}
      placeholder={i18next.t('Search:Placeholder')}
      onChange={async e => {
        const newValue = e.valueOf()
        props.updateSearchValue(newValue)

        try {
          const result = await loadSearchSuggestion(newValue)
          if (result.kind === "result") {
            props.updateSuggestions(result.value.toArray())
          } else {
            props.updateSuggestions([])
          }
        } catch (err) {
          console.error("Suggestion fetch error:", err)
          props.updateSuggestions([])
        }

      }}
    />

    <button className="searchform__submit" type="submit">
      <span className="sr-text">Zoeken</span>
      <SharedBlockLayout.SVGIcon iconId='#icon--search' width='24px' height='24px' className="searchform__icon" />
    </button>
  </form>
)

export const SearchButtonLayout = (props: SearchButtonProps) => {
  return (
    <li className={`sh__extra-item sh__extra-item--search search__icon-style ${props.display == 'desktop' ? '' : "sh__nav-item"}`} key="dk-e-s">
      <button
        className={`link link--secondary link--iconed sh__extra-link ${props.show === true ? 'active' : ''}`}
        aria-controls="a11y-search"
        aria-expanded={props.show}
        onClick={_ => {
          props.setShow(!props.show)
          const searchField:HTMLElement | null = document.querySelector('#a11y-search-input')
          searchField != null && searchField.focus()
        }}
      >
        <span className="link__label sr-text">Zoeken</span>
        <svg className="link__icon" width="24px" height="24px" aria-hidden="true"><use fill="#D33350" xlinkHref={props.show === false ? "#icon--search" : "#icon--close"} /></svg>
      </button>
    </li>
  )
}

export const SearchBarLayout = (props: SearchBarProps) => (
  <div id="a11y-search" className='sh__overlay searchform shsf shsf--overlay' aria-hidden={!props.show}>
    <div className='sh__overlay-inner shsf__inner ls-spacing--s'>
      <SearchPageLayout.SearchHeader>
        {SearchFormLayout({
          searchValue: props.searchValue,
          updateSearchValue: props.updateSearchValue,
          label: 'Zoek binnen reumanederland.nl',
          show: props.show,
          updateSuggestions: props.updateSuggestions,
          suggestions: props.suggestions,
        })}
      </SearchPageLayout.SearchHeader>
      <Suggestions items={props.suggestions} />
    </div>
  </div>
)
const Suggestions = ({ items }: { items: ParsedOverviewDetailItem[] }) => {
  if (!items?.length) return null

  return (
    <div className="ls-container ls-gutter">
      <ul className="searchform__suggestions">
        {items.map((item, index) => (
          <li key={index} className="searchform__suggestion-item">
            <a href={item.Link?.url || '#'} className="searchform__suggestion-link">
              {item.Title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}
